{
  "chart": "Patient Chart",
  "mrn": "MRN",
  "demographics": {
    "pageTitle": "Demographics",
    "loading": "Loading patient demographics...",
    "loadError": "Failed to load patient demographics.",
    "returnToDashboard": "Return to Dashboard",
    "updatedSuccess": "Patient demographics updated",
    "updateError": "Failed to update patient demographics",
    "sections": {
      "personalInformation": "Personal Information",
      "identification": "Identification",
      "contactInformation": "Contact Information",
      "address": "Address",
      "languageAndPreferences": "Language & Preferences",
      "specialFlags": "Special Flags",
      "recordInformation": "Record Information"
    },
    "fields": {
      "fullName": "Full Name",
      "alternativeName": "Alternative Name",
      "preferredName": "Preferred Name",
      "dateOfBirth": "Date of Birth",
      "birthTime": "Time of Birth",
      "age": "Age",
      "legalGender": "Legal Gender",
      "genderIdentity": "Gender Identity",
      "sexAtBirth": "Sex at Birth",
      "race": "Race",
      "ethnicity": "Ethnicity",
      "nationality": "Nationality",
      "mrn": "MRN",
      "nationalIdType": "National ID Type",
      "nationalIdNumber": "National ID Number",
      "passportNumber": "Passport Number",
      "passportCountry": "Passport Country",
      "primaryPhone": "Primary Phone",
      "mobilePhone": "Mobile Phone",
      "email": "Email",
      "preferredContactMethod": "Preferred Contact Method",
      "addressLine1": "Address Line 1",
      "addressLine2": "Address Line 2",
      "city": "City",
      "stateProvince": "State/Province",
      "postalCode": "Postal Code",
      "country": "Country",
      "primaryLanguage": "Primary Language",
      "secondaryLanguage": "Secondary Language",
      "interpreterRequired": "Interpreter Required",
      "vipStatus": "VIP Status",
      "confidentialityLevel": "Confidentiality Level",
      "medicalTourist": "Medical Tourist",
      "homeCountry": "Home Country",
      "status": "Status",
      "deceased": "Deceased",
      "created": "Created",
      "lastModified": "Last Modified",
      "passportOnFile": "Passport on File",
      "organDonorStatus": "Organ Donor Status"
    },
    "statusValues": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "deceasedSummary": "Yes ({{date}})",
    "deceasedDateUnknown": "Date unknown",
    "legalGender": {
      "label": "Legal Gender",
      "values": {
        "male": "Male",
        "female": "Female",
        "other": "Other",
        "unknown": "Unknown"
      },
      "selectPlaceholder": "Select Gender"
    },
    "sexAtBirth": {
      "label": "Sex at Birth",
      "values": {
        "female": "Female",
        "male": "Male",
        "other": "Other",
        "unknown": "Unknown"
      },
      "notRecorded": "Not recorded"
    },
    "preferredContactMethod": {
      "label": "Preferred Contact Method",
      "values": {
        "phone": "Phone",
        "mobile": "Mobile",
        "email": "Email",
        "sms": "SMS"
      },
      "notSpecified": "Not specified"
    },
    "validation": {
      "fullNameRequired": "Full name is required",
      "dateOfBirthRequired": "Date of birth is required",
      "countryRequired": "Country is required",
      "primaryLanguageRequired": "Primary language is required",
      "invalidEmail": "Invalid email",
      "nationalIdValidationFailed": "National ID validation failed: {{error}}",
      "invalidBirthTime": "Time of birth must be HH:MM"
    },
    "organDonor": {
      "notRecorded": "Not recorded",
      "registered": "Registered donor",
      "optedOut": "Opted out",
      "notRegistered": "Not registered",
      "unknown": "Unknown"
    }
  },
  "registration": {
    "title": "Patient Registration",
    "subtitle": "Register a new patient in the system",
    "submit": "Register Patient",
    "submitting": "Registering...",
    "checkingDuplicates": "Checking for duplicates...",
    "registerNew": "Register New Patient",
    "registeredSuccess": "Patient registered successfully",
    "registerError": "Failed to register patient",
    "validationNationalIdFailed": "National ID validation failed: {{error}}",
    "sections": {
      "basicInformation": "Basic Information",
      "identification": "Identification",
      "contactInformation": "Contact Information",
      "address": "Address",
      "languageAndCommunication": "Language & Communication",
      "additionalInformation": "Additional Information"
    },
    "fields": {
      "facility": "Registration facility"
    },
    "placeholders": {
      "fullName": "e.g., Tan Wei Ming or 李小明",
      "alternativeName": "Romanized version if applicable",
      "preferredName": "Name patient prefers to be called",
      "nationalIdNumberDefault": "Enter national ID number",
      "primaryPhone": "+65 9123 4567",
      "mobilePhone": "+65 8123 4567",
      "email": "patient@example.com",
      "facility": "Select a facility"
    },
    "helperText": {
      "fullName": "Enter the patient's full name as it appears on official documents",
      "facility": "The facility this patient is being registered at. Staff there will be able to open the record."
    },
    "flags": {
      "vipPatient": "VIP Patient",
      "medicalTourist": "Medical Tourist"
    },
    "duplicate": {
      "title": "Potential Duplicate Patients Found",
      "body": "The following existing patients match the information you entered:",
      "mrnLabel": "MRN",
      "dobLabel": "DOB",
      "idLabel": "ID",
      "matchSummary": "Match: {{score}}% ({{reasons}})",
      "useExisting": "Use Existing",
      "createNew": "This is a New Patient",
      "restricted": {
        "title_one": "{{count}} possible match exists that you cannot view",
        "title_other": "{{count}} possible matches exist that you cannot view",
        "body": "This patient may already have a record at another facility. Contact Health Information Management before creating a new one — details are withheld because the record is outside your access."
      },
      "overrideReasonLabel": "Reason for registering anyway",
      "overrideReasonPlaceholder": "e.g. confirmed with the patient that this is a different person",
      "overrideReasonHelp": "Recorded against your account. Registering a second record for the same person splits their chart.",
      "registerAnyway": "Register anyway"
    }
  },
  "search": {
    "title": "Patient Search",
    "subtitle": "Search and manage patient records",
    "placeholder": "Search by patient name, MRN, or ID...",
    "advancedFilters": "Advanced Filters",
    "filters": {
      "mrnPlaceholder": "e.g., P0000000001",
      "fullNamePlaceholder": "Patient name",
      "phonePlaceholder": "Phone number",
      "emailPlaceholder": "Email address"
    },
    "filterLabels": {
      "mrn": "MRN",
      "fullName": "Full Name",
      "dateOfBirth": "Date of Birth",
      "phone": "Phone",
      "email": "Email",
      "country": "Country",
      "status": "Status",
      "vip": "VIP"
    },
    "vipFilter": {
      "all": "All",
      "vipOnly": "VIP Only",
      "nonVipOnly": "Non-VIP Only"
    },
    "statusFilter": {
      "all": "All",
      "active": "Active",
      "inactive": "Inactive"
    },
    "countryFilter": {
      "all": "All Countries"
    },
    "clearFilters": "Clear Filters",
    "dateOfBirthAria": "Date of Birth filter",
    "columns": {
      "mrn": "MRN",
      "fullName": "Full Name",
      "dob": "DOB",
      "gender": "Gender",
      "phone": "Phone",
      "country": "Country",
      "status": "Status"
    },
    "results": {
      "searching": "Searching patients...",
      "loadError": "Failed to load patients. Please try again.",
      "retry": "Retry",
      "empty": "No patients found. Try adjusting your search criteria.",
      "showing": "Showing {{from}} to {{to}} of {{total}} patients"
    }
  },
  "myPatients": {
    "title": "My Patients",
    "subtitle": "Active patients under your care",
    "searchPlaceholder": "Filter by name or MRN...",
    "columns": {
      "mrn": "MRN",
      "patient": "Full Name",
      "dob": "DOB",
      "sex": "Sex",
      "class": "Class",
      "relationship": "Relationship",
      "admitted": "Admitted"
    },
    "kind": {
      "attending": "Attending",
      "careTeam": "Care team",
      "referral": "Referral",
      "coverage": "Coverage"
    },
    "restrictedBadge": "Restricted",
    "empty": {
      "title": "No patients on your panel",
      "body": "Patients you attend, cover, or receive by referral will appear here.",
      "censusAction": "Open census"
    },
    "results": {
      "searching": "Loading your patients...",
      "loadError": "Failed to load your patients. Please try again.",
      "retry": "Retry",
      "showing": "Showing {{from}} to {{to}} of {{total}} patients"
    },
    "__review_myPatientsKinds": "Relationship badges (attending/care team/referral/coverage) and panel chrome are first-pass clinical vocabulary; needs APAC sign-off per locale."
  },
  "encounters": {
    "title": "Encounters",
    "create": "Create Encounter",
    "filters": "Filters",
    "filterLabels": {
      "status": "Status",
      "class": "Class",
      "fromDate": "From Date",
      "toDate": "To Date"
    },
    "filterPlaceholders": {
      "allStatuses": "All Statuses",
      "allClasses": "All Classes"
    },
    "clearFilters": "Clear Filters",
    "fromDateAria": "From Date",
    "toDateAria": "To Date",
    "columns": {
      "encounterNumber": "Encounter #",
      "class": "Class",
      "status": "Status",
      "admitDate": "Admit Date",
      "dischargeDate": "Discharge Date",
      "location": "Location",
      "chiefComplaint": "Chief Complaint"
    },
    "locationLabel": "Location #{{id}}",
    "loading": "Loading encounters...",
    "loadError": "Failed to load encounters.",
    "empty": "No encounters found for this patient.",
    "showing": "Showing {{from}} to {{to}} of {{total}}"
  },
  "identifiers": {
    "nationalIdType": {
      "label": "National ID Type",
      "none": "None",
      "values": {
        "nric": "NRIC",
        "hkid": "HKID",
        "myKad": "MyKad",
        "aadhaar": "Aadhaar",
        "ktp": "KTP",
        "myNumber": "My Number",
        "thaiNationalId": "Thai National ID"
      },
      "country": {
        "nric": "Singapore",
        "hkid": "Hong Kong",
        "myKad": "Malaysia",
        "aadhaar": "India",
        "ktp": "Indonesia",
        "myNumber": "Japan",
        "thaiNationalId": "Thailand"
      },
      "placeholderByType": {
        "nric": "e.g., S1234567D",
        "myKad": "e.g., 850101-14-5678",
        "hkid": "e.g., A123456(3)",
        "aadhaar": "e.g., 2341 2341 2346",
        "thaiNationalId": "e.g., 1-2345-45678-78-1"
      }
    },
    "nationalIdCheck": {
      "checksumMismatch": "The check character does not match this ID type. Verify the number against the patient's identity document.",
      "unavailable": "This ID number could not be checked. Verify it against the patient's identity document.",
      "acknowledge": "I have verified this number against the identity document",
      "acknowledgeRequired": "Verify the national ID number against the identity document and confirm before saving."
    },
    "__review_nationalIdType": "Country-specific identifier verbiage — verify with local clinical/admin reviewer before APAC pilot rollout",
    "__review_nationalIdCheck": "Clinical-safety wording: the check-character warning is ADVISORY (registrar verifies against the document) — verify with local registration reviewer before APAC pilot rollout"
  },
  "country": {
    "values": {
      "sg": "Singapore",
      "my": "Malaysia",
      "th": "Thailand",
      "id": "Indonesia",
      "ph": "Philippines",
      "vn": "Vietnam",
      "hk": "Hong Kong",
      "tw": "Taiwan",
      "jp": "Japan",
      "kr": "South Korea",
      "cn": "China",
      "in": "India",
      "au": "Australia",
      "nz": "New Zealand"
    }
  },
  "language": {
    "values": {
      "en": "English",
      "zh": "Chinese (Mandarin)",
      "ms": "Malay",
      "ta": "Tamil",
      "th": "Thai",
      "id": "Indonesian",
      "vi": "Vietnamese",
      "ja": "Japanese",
      "ko": "Korean",
      "hi": "Hindi"
    }
  },
  "contact": {
    "addTitle": "Add Contact",
    "editTitle": "Edit Contact",
    "name": "Name",
    "relationship": {
      "label": "Relationship",
      "selectPlaceholder": "Select...",
      "values": {
        "spouse": "Spouse",
        "parent": "Parent",
        "child": "Child",
        "sibling": "Sibling",
        "guardian": "Guardian",
        "friend": "Friend",
        "other": "Other"
      }
    },
    "phone": "Phone",
    "email": "Email",
    "emergencyContact": "Emergency contact",
    "validation": {
      "nameRequired": "Contact name is required",
      "relationshipRequired": "Relationship is required",
      "phoneRequired": "Phone number is required",
      "invalidEmail": "Invalid email"
    },
    "savedSuccess": "Contact added successfully",
    "saveError": "Failed to add contact"
  },
  "immunization": {
    "addTitle": "Add Immunization",
    "vaccineName": "Vaccine Name",
    "vaccineNamePlaceholder": "e.g., Influenza, COVID-19 (Pfizer), Hepatitis B",
    "vaccineCode": "Vaccine Code (CVX)",
    "vaccineCodePlaceholder": "e.g., 141",
    "administeredDate": "Date Administered",
    "lotNumber": "Lot Number",
    "lotNumberPlaceholder": "e.g., AB1234",
    "site": {
      "label": "Site",
      "selectPlaceholder": "Select site",
      "values": {
        "leftDeltoid": "Left Deltoid",
        "rightDeltoid": "Right Deltoid",
        "leftThigh": "Left Thigh",
        "rightThigh": "Right Thigh",
        "leftGluteal": "Left Gluteal",
        "rightGluteal": "Right Gluteal",
        "other": "Other"
      }
    },
    "route": {
      "label": "Route",
      "selectPlaceholder": "Select route",
      "values": {
        "intramuscular": "Intramuscular (IM)",
        "subcutaneous": "Subcutaneous (SC)",
        "intradermal": "Intradermal (ID)",
        "oral": "Oral",
        "intranasal": "Intranasal"
      }
    },
    "__review_route": "Route abbreviations (IM, SC, ID) stay verbatim; APAC pharmacopoeia register varies — verify with local pharmacy/clinical reviewer.",
    "doseAmount": "Dose Amount",
    "doseAmountPlaceholder": "e.g., 0.5 mL",
    "administeredBy": "Administered By",
    "administeredByPlaceholder": "Provider name or ID",
    "nextDueDate": "Next Due Date",
    "notes": "Notes",
    "notesPlaceholder": "Additional notes...",
    "validation": {
      "vaccineNameRequired": "Vaccine name is required",
      "administeredDateRequired": "Date administered is required"
    },
    "savedSuccess": "Immunization record added",
    "saveError": "Failed to add immunization record"
  },
  "insurance": {
    "addTitle": "Add Insurance Plan",
    "submitLabel": "Add Insurance",
    "payerName": "Payer Name",
    "payerNamePlaceholder": "e.g., AIA Singapore",
    "payerId": "Payer ID",
    "payerIdPlaceholder": "Payer identifier",
    "planName": "Plan Name",
    "planNamePlaceholder": "e.g., HealthShield Gold Max",
    "planType": {
      "label": "Plan Type",
      "selectPlaceholder": "Select type",
      "values": {
        "hmo": "HMO",
        "ppo": "PPO",
        "epo": "EPO",
        "pos": "POS",
        "government": "Government",
        "private": "Private",
        "corporate": "Corporate",
        "other": "Other"
      }
    },
    "memberId": "Member ID",
    "memberIdPlaceholder": "Member ID number",
    "policyNumber": "Policy Number",
    "policyNumberPlaceholder": "Enter policy number",
    "groupNumber": "Group Number",
    "groupNumberPlaceholder": "Group number",
    "subscriberName": "Subscriber Name",
    "subscriberNamePlaceholder": "If different from patient",
    "subscriberRelationship": {
      "label": "Subscriber Relationship",
      "values": {
        "self": "Self",
        "spouse": "Spouse",
        "child": "Child",
        "parent": "Parent",
        "other": "Other"
      }
    },
    "priority": {
      "label": "Priority",
      "values": {
        "primary": "Primary",
        "secondary": "Secondary",
        "tertiary": "Tertiary"
      }
    },
    "effectiveDate": "Effective Date",
    "terminationDate": "Termination Date",
    "copayAmount": "Copay Amount ($)",
    "coinsurancePercent": "Coinsurance (%)",
    "deductibleAmount": "Deductible ($)",
    "outOfPocketMax": "Out-of-Pocket Max ($)",
    "preAuthRequired": "Pre-authorization Required",
    "notes": "Notes",
    "notesPlaceholder": "Additional notes...",
    "validation": {
      "payerNameRequired": "Payer name is required",
      "planNameRequired": "Plan name is required",
      "memberIdRequired": "Member ID is required",
      "effectiveDateRequired": "Effective date is required"
    },
    "savedSuccess": "Insurance plan added",
    "saveError": "Failed to add insurance plan"
  },
  "problem": {
    "addTitle": "Add Problem",
    "problemName": "Problem Name",
    "problemNamePlaceholder": "e.g., Type 2 Diabetes Mellitus",
    "icdCode": "ICD-10 Code",
    "icdSearchPlaceholder": "Search ICD-10 code or description...",
    "onsetDate": "Onset Date",
    "severity": {
      "label": "Severity",
      "values": {
        "mild": "Mild",
        "moderate": "Moderate",
        "severe": "Severe"
      }
    },
    "__review_severity": "Severity grading (mild/moderate/severe) for problems mirrors allergy.severity but the APAC clinical register may differ — verify with local clinical reviewer.",
    "notes": "Notes",
    "notesPlaceholder": "Additional clinical notes...",
    "validation": {
      "problemNameRequired": "Problem name is required"
    },
    "savedSuccess": "Problem added to problem list",
    "saveError": "Failed to add problem"
  },
  "accounts": {
    "pageTitle": "Patient Accounts",
    "backToDashboard": "Dashboard",
    "searchPatientLabel": "Search Patient",
    "searchPlaceholder": "Search by name or MRN...",
    "searching": "Searching...",
    "noPatientsFound": "No patients found",
    "loadingAccount": "Loading account...",
    "mrnLabel": "MRN",
    "generateStatement": "Generate Statement",
    "statementComingSoon": "Statement generation coming soon",
    "paymentPlan": "Payment Plan",
    "paymentPlanComingSoon": "Payment plan setup coming soon",
    "totalCharges": "Total Charges",
    "totalPayments": "Total Payments",
    "adjustments": "Adjustments",
    "outstandingBalance": "Outstanding Balance",
    "transactionHistory": "Transaction History",
    "columns": {
      "date": "Date",
      "type": "Type",
      "description": "Description",
      "amount": "Amount",
      "balance": "Balance"
    },
    "transactionType": {
      "label": "Type",
      "values": {
        "charge": "Charge",
        "payment": "Payment",
        "adjustment": "Adjustment"
      }
    },
    "loadingTransactions": "Loading transactions...",
    "noTransactionsFound": "No transactions found",
    "emptyState": "Search for a patient to view their account"
  },
  "proxies": {
    "title": "Authorized Representatives",
    "description": "Caregivers, guardians, and legal representatives authorized to access this patient's portal data. Revoked entries are kept for audit.",
    "addProxy": "Add Proxy",
    "newRelationshipHeading": "New proxy relationship",
    "proxyUserId": "Proxy user ID",
    "proxyUserIdPlaceholder": "User ID (from Admin → Users)",
    "proxyUserIdHelper": "Look up in Admin → Users. User-picker component comes in a follow-up.",
    "relationship": {
      "label": "Relationship",
      "values": {
        "parent": "Parent",
        "legalGuardian": "Legal Guardian",
        "spousePartner": "Spouse / Partner",
        "adultChild": "Adult Child",
        "powerOfAttorney": "Power of Attorney",
        "healthcareAgent": "Healthcare Agent"
      }
    },
    "accessLevel": {
      "label": "Access level",
      "values": {
        "full": "Full",
        "limited": "Limited",
        "emergency": "Emergency"
      },
      "descriptions": {
        "full": "All portal data — appointments, results, messages, forms.",
        "limited": "Appointments + messages only (typical for adolescents).",
        "emergency": "Break-glass-equivalent for healthcare agents when the patient is incapacitated."
      }
    },
    "__review_accessLevel": "Proxy access tiers and their plain-language descriptions touch consent/legal-guardianship terminology — verify register with local clinical/legal reviewer.",
    "startDate": "Start date",
    "endDate": "End date",
    "startDateAria": "Effective start date",
    "endDateAria": "Effective end date",
    "grantAccess": "Grant proxy access",
    "userIdRequired": "Proxy user id required",
    "createdSuccess": "Proxy relationship created",
    "duplicateError": "This person is already a proxy with that relationship",
    "invalidDataError": "Invalid proxy data",
    "createError": "Failed to create proxy",
    "revokedSuccess": "Proxy access revoked",
    "revokeError": "Failed to revoke proxy",
    "emptyState": "No proxies configured. Grant access to a caregiver, guardian, or healthcare agent using the button above.",
    "sections": {
      "active": "Active ({{count}})",
      "plannedInactive": "Planned / Inactive ({{count}})",
      "revoked": "Revoked ({{count}})"
    },
    "userIdFallback": "User #{{id}}",
    "noEndDate": "(no end date)",
    "revokedOn": "Revoked {{date}}",
    "revokeTitle": "Revoke proxy access",
    "confirmRevokeTitle": "Revoke proxy access?",
    "confirmRevokeBody": "{{name}} will lose access to this patient's portal data immediately. The record stays in the audit trail.",
    "confirmRevokeLabel": "Revoke access"
  },
  "merge": {
    "title": "Patient Merge",
    "description": "Merge duplicate patient records. The source patient will be deactivated and all clinical data will be moved to the target (surviving) patient.",
    "sourceLabel": "Source Patient (will be deactivated)",
    "targetLabel": "Target Patient (surviving record)",
    "clearSelection": "Clear selection",
    "searchPlaceholder": "Search by name, MRN, or phone...",
    "fields": {
      "mrn": "MRN",
      "dob": "DOB",
      "gender": "Gender",
      "country": "Country",
      "phone": "Phone",
      "email": "Email"
    },
    "counts": {
      "encounters": "Encounters: {{count}}",
      "allergies": "Allergies: {{count}}",
      "problems": "Problems: {{count}}"
    },
    "samePatientWarning": "Source and target must be different patients.",
    "comparisonTitle": "Demographics Comparison",
    "comparisonSubtitle": "Differences are highlighted in amber.",
    "columns": {
      "field": "Field",
      "source": "Source ({{mrn}})",
      "target": "Target ({{mrn}})"
    },
    "comparisonLabels": {
      "fullName": "Full Name",
      "mrn": "MRN",
      "dateOfBirth": "Date of Birth",
      "gender": "Gender",
      "phone": "Phone",
      "email": "Email",
      "country": "Country",
      "nationalId": "National ID"
    },
    "reasonLabel": "Merge Reason",
    "reasonPlaceholder": "Reason for merging these records (required)",
    "notesLabel": "Notes (optional)",
    "notesPlaceholder": "Additional notes about this merge",
    "mergeButton": "Merge Patients",
    "mergeSuccess": "Patients merged successfully",
    "mergeError": "Failed to merge patients",
    "successHeading": "Merge completed successfully.",
    "successBodyPrefix": "Patient {{mrn}} has been deactivated. All clinical data has been moved to ",
    "successBodySuffix": ".",
    "confirmTitle": "Confirm Patient Merge",
    "confirmBodyPrefix": "This action ",
    "confirmBodyEmphasis": "CANNOT be undone",
    "confirmBodySuffix": ". Patient {{sourceMrn}} ({{sourceName}}) will be deactivated and all clinical data will be moved to Patient {{targetMrn}} ({{targetName}}).",
    "confirmButton": "Yes, Merge Patients",
    "swapSides": "Swap source and target",
    "preloadError": "Could not load the selected records.",
    "detailLoadError": "Could not load the patient record."
  },
  "allergy": {
    "addTitle": "Add Allergy",
    "editTitle": "Edit Allergy",
    "allergen": "Allergen",
    "allergenPlaceholder": "e.g., Penicillin, Peanuts",
    "type": "Type",
    "typeOptions": {
      "drug": "Drug",
      "food": "Food",
      "environmental": "Environmental"
    },
    "severityLabel": "Severity",
    "severity": {
      "mild": "Mild",
      "moderate": "Moderate",
      "severe": "Severe",
      "lifeThreatening": "Life-Threatening"
    },
    "__review_severity": "APAC clinical severity grading varies — verify with local clinical reviewer before APAC pilot rollout",
    "reaction": "Reaction",
    "reactionPlaceholder": "e.g., Hives, Anaphylaxis, Nausea",
    "reactionOptions": {
      "rash": "Rash",
      "hives": "Hives",
      "anaphylaxis": "Anaphylaxis",
      "swelling": "Swelling",
      "itching": "Itching",
      "other": "Other"
    },
    "onsetDate": "Onset Date",
    "notes": "Notes",
    "notesPlaceholder": "Additional notes...",
    "verifiedBy": "Verified By",
    "noKnownAllergies": "No Known Allergies",
    "savedSuccess": "Allergy added successfully",
    "saveError": "Failed to add allergy",
    "deletedSuccess": "Allergy removed"
  },
  "components": {
    "allergyBadge": {
      "title": "{{name}} ({{type}}) - {{severity}}"
    },
    "bradenScale": {
      "title": "Braden Scale (Pressure Injury Risk)",
      "footer": "Total range: 6-23. Lower scores indicate higher risk for pressure injury development.",
      "scoreFormat": "Score: {{score}} — {{riskBand}}",
      "riskBand": {
        "veryHigh": "Very High Risk",
        "high": "High Risk",
        "moderate": "Moderate Risk",
        "mild": "Mild Risk",
        "none": "No Risk"
      },
      "subscales": {
        "sensoryPerception": {
          "label": "{{n}}. Sensory Perception",
          "options": {
            "1": "{{n}} - Completely limited",
            "2": "{{n}} - Very limited",
            "3": "{{n}} - Slightly limited",
            "4": "{{n}} - No impairment"
          }
        },
        "moisture": {
          "label": "{{n}}. Moisture",
          "options": {
            "1": "{{n}} - Constantly moist",
            "2": "{{n}} - Very moist",
            "3": "{{n}} - Occasionally moist",
            "4": "{{n}} - Rarely moist"
          }
        },
        "activity": {
          "label": "{{n}}. Activity",
          "options": {
            "1": "{{n}} - Bedfast",
            "2": "{{n}} - Chairfast",
            "3": "{{n}} - Walks occasionally",
            "4": "{{n}} - Walks frequently"
          }
        },
        "mobility": {
          "label": "{{n}}. Mobility",
          "options": {
            "1": "{{n}} - Completely immobile",
            "2": "{{n}} - Very limited",
            "3": "{{n}} - Slightly limited",
            "4": "{{n}} - No limitation"
          }
        },
        "nutrition": {
          "label": "{{n}}. Nutrition",
          "options": {
            "1": "{{n}} - Very poor",
            "2": "{{n}} - Probably inadequate",
            "3": "{{n}} - Adequate",
            "4": "{{n}} - Excellent"
          }
        },
        "frictionShear": {
          "label": "{{n}}. Friction & Shear",
          "options": {
            "1": "{{n}} - Problem",
            "2": "{{n}} - Potential problem",
            "3": "{{n}} - No apparent problem"
          }
        }
      },
      "__review_bradenScale": "APAC nursing-practice variance — risk-band thresholds (≤9/10-12/13-14/15-18/19-23) and categorical labels are the published Braden cutoffs; SG/HK/TW/JP local conventions may differ. Reviewer to confirm whether facility nursing policies use the same cutoffs and whether localized labels match clinical-team terminology."
    },
    "morseFallScale": {
      "title": "Morse Fall Scale",
      "scoreFormat": "Score: {{score}} — {{riskBand}}",
      "subscales": {
        "historyOfFalling": {
          "label": "{{n}}. History of Falling",
          "options": {
            "0": "No ({{score}})",
            "25": "Yes ({{score}})"
          }
        },
        "secondaryDiagnosis": {
          "label": "{{n}}. Secondary Diagnosis",
          "options": {
            "0": "No ({{score}})",
            "15": "Yes ({{score}})"
          }
        },
        "ambulatoryAid": {
          "label": "{{n}}. Ambulatory Aid",
          "options": {
            "0": "None / Bed rest / Nurse assist ({{score}})",
            "15": "Crutches / Cane / Walker ({{score}})",
            "30": "Furniture ({{score}})"
          }
        },
        "ivHeparinLock": {
          "label": "{{n}}. IV / Heparin Lock",
          "options": {
            "0": "No ({{score}})",
            "20": "Yes ({{score}})"
          }
        },
        "gait": {
          "label": "{{n}}. Gait",
          "options": {
            "0": "Normal / Bed rest / Wheelchair ({{score}})",
            "10": "Weak ({{score}})",
            "20": "Impaired ({{score}})"
          }
        },
        "mentalStatus": {
          "label": "{{n}}. Mental Status",
          "options": {
            "0": "Oriented to own ability ({{score}})",
            "15": "Overestimates / Forgets limitations ({{score}})"
          }
        }
      },
      "interventions": {
        "high": "High Risk Interventions: Implement standard fall prevention. Place fall risk armband on patient. Post fall risk sign at bedside. Educate patient and family. Keep bed in lowest position with brakes locked. Ensure call light within reach. Non-skid footwear. Toileting schedule. Consider 1:1 supervision if needed.",
        "moderate": "Moderate Risk Interventions: Implement standard fall prevention. Place fall risk armband on patient. Educate patient and family. Keep bed in lowest position with brakes locked. Ensure call light within reach. Non-skid footwear.",
        "low": "Low Risk Interventions: Good basic nursing care. Educate patient on safe mobility. Orient to environment and call light use."
      },
      "__review_morseFallScale": "APAC nursing-practice variance — Morse Fall Scale risk-band thresholds (>=45 / >=25 / <25) and intervention recommendations are the standard published cutoffs; SG/HK/TW/JP/KR/AU local facility policies may differ. The fall-risk armband / non-skid footwear / 1:1 supervision recommendations reflect US/SG nursing practice; JP convention (転倒防止) and KR convention (낙상 예방) MAY have different categorical labels for the assistive devices and intervention tiers. Reviewer to confirm whether facility nursing policies use the same cutoffs and whether localized intervention paragraphs match clinical-team terminology. Note: risk-band labels themselves are REUSED from patient.banner.fallRisk.* (see PatientBanner / EncounterCensus) — review there."
    }
  },
  "banner": {
    "label": "Patient information",
    "vip": "VIP",
    "vipTitle": "VIP Patient",
    "mrn": "MRN",
    "dob": "DOB",
    "ageSuffix": "y",
    "sex": "Sex",
    "codeStatusAria": "Code status: {{status}}",
    "isolationAria": "Isolation: {{status}}",
    "isolation": {
      "contact": "Contact",
      "droplet": "Droplet",
      "airborne": "Airborne",
      "none": "None"
    },
    "__review_isolation": "Infection-control terminology may have facility-specific or jurisdictional preferences (e.g., 'enteric' for contact in some APAC settings) — verify with infection-control SMEs.",
    "fallRiskAria": "Fall risk: {{level}}",
    "fallRisk": {
      "label": "Fall Risk",
      "low": "Low",
      "moderate": "Moderate",
      "high": "High"
    },
    "pressureInjuryRisk": "Pressure Risk",
    "pressureInjuryRiskAria": "Pressure injury risk: {{level}}",
    "__review_pressureInjuryRisk": "APAC pressure-injury terminology: each locale's wording is taken from its OWN existing components.bradenScale.title rather than translated afresh, so the banner badge and the scale that produces it read identically (ja 褥瘡 / zh-CN 压疮 / zh-HK+zh-TW 壓瘡 / ko 욕창 / vi loét tì đè / th แผลกดทับ). Level labels are NOT duplicated here — the badge reuses components.bradenScale.riskBand.* via enumLabel, the same enum-reuse convention MorseFallScale uses for banner.fallRisk. Nursing lead per APAC market confirms wording before ship.",
    "interpreter": "Interpreter",
    "interpreterRequired": "Interpreter required — {{language}}",
    "languageNotSpecified": "language not specified",
    "weightKg": "{{weight}} kg",
    "allergiesLabel": "Allergies",
    "moreAllergies_one": "+{{count}} more",
    "moreAllergies_other": "+{{count}} more",
    "nkda": "NKDA",
    "allergiesUnknown": "Allergies unknown — load failed"
  },
  "__review_banner": "Banner acronyms (MRN, DOB, NKDA, VIP, kg) stay verbatim across all locales — these are clinical/Latin-script conventions in APAC EMR practice.",
  "chartFrame": {
    "navAriaLabel": "Patient chart navigation",
    "tabs": {
      "summary": "Summary",
      "encounters": "Encounters",
      "orders": "Orders",
      "results": "Results",
      "medications": "Medications",
      "notes": "Notes",
      "problems": "Problems",
      "allergies": "Allergies",
      "immunizations": "Immunizations",
      "intakeOutput": "I/O",
      "carePlans": "Care Plans",
      "referrals": "Referrals",
      "familyHistory": "Family History",
      "socialHistory": "Social History",
      "surgicalHistory": "Surgical History",
      "advanceDirectives": "Advance Directives",
      "insurance": "Insurance",
      "contacts": "Contacts",
      "proxies": "Proxies",
      "identifiers": "Identifiers",
      "addresses": "Addresses",
      "consents": "Consents",
      "pregnancyStatus": "Pregnancy",
      "implantableDevices": "Devices",
      "ccdaImports": "C-CDA Imports"
    },
    "__review_tabs": "Tab labels span clinical, admin, and history modules — Tamil, Hindi, and zh-HK in particular should be reviewed for register and module-name fit. Pages for Notes/Results/Medications stay English until later phases; only the tab label is translated here.",
    "groups": {
      "clinical": "Clinical",
      "history": "History",
      "admin": "Admin"
    },
    "breakGlass": {
      "auditBanner": "BREAK-GLASS ACCESS — All activity is being audited. Access expires in 15 minutes.",
      "dialogTitle": "Restricted Patient Record",
      "dialogSubtitle": "Break-glass access required",
      "dialogBody": "This patient record is restricted. You must provide a justification to access it. All break-glass access is logged and audited.",
      "justificationLabel": "Justification",
      "justificationPlaceholder": "Enter clinical justification for accessing this restricted record...",
      "justificationRequired": "Justification is required for break-glass access.",
      "requestError": "Failed to request break-glass access. Please try again or contact an administrator.",
      "submitButton": "Access Record",
      "submitting": "Requesting...",
      "passwordLabel": "Confirm your password",
      "passwordPlaceholder": "Re-enter your password",
      "passwordRequired": "Your password is required for emergency access.",
      "passwordIncorrect": "Incorrect password. Please try again.",
      "passwordHelp": "Confirms it is you at this workstation.",
      "totpLabel": "Authenticator code",
      "totpPlaceholder": "6-digit code",
      "totpRequired": "Your authenticator code is required for emergency access.",
      "totpIncorrect": "Incorrect code. Please try again.",
      "totpHelp": "Confirms it is you at this workstation.",
      "totpEnrollHint": "No authenticator enrolled — enroll one in your profile to use emergency access."
    },
    "invalidId": {
      "title": "Invalid Patient ID",
      "body": "The patient ID provided is not valid.",
      "action": "Search Patients"
    },
    "notFound": {
      "title": "Patient Not Found",
      "body": "Unable to load patient data. The patient may not exist or you may not have access.",
      "action": "Search Patients"
    },
    "loadError": {
      "title": "Failed to Load Patient Chart",
      "body": "The chart could not be loaded. Please try again.",
      "action": "Retry"
    }
  },
  "address": {
    "title": "Addresses",
    "addAddress": "Add Address",
    "newTitle": "New Address",
    "editTitle": "Edit Address",
    "loading": "Loading addresses...",
    "loadError": "Failed to load address information.",
    "empty": "No addresses on file.",
    "addressType": {
      "label": "Type",
      "values": {
        "home": "Home",
        "work": "Work",
        "temporary": "Temporary",
        "billing": "Billing"
      }
    },
    "__review_addressType": "Address-type taxonomy varies by APAC jurisdiction (e.g., 'correspondence' vs 'mailing', some markets distinguish 'rented' vs 'owned') — verify with local admin/clinical reviewer before APAC pilot rollout.",
    "fields": {
      "addressLine1": "Address Line 1",
      "addressLine2": "Address Line 2",
      "addressLine3": "Address Line 3",
      "district": "District",
      "city": "City",
      "stateProvince": "State / Province",
      "postalCode": "Postal Code",
      "country": "Country"
    },
    "placeholders": {
      "addressLine1": "Street address",
      "addressLine2": "Apt, unit, floor",
      "addressLine3": "Building, block",
      "district": "District / ward",
      "postalCode": "e.g. 123456",
      "country": "e.g. SG"
    },
    "primaryBadge": "Primary",
    "setPrimary": "Set as primary address",
    "primaryHelper": "(other addresses will be unset as primary)",
    "fromLabel": "From: {{date}}",
    "toLabel": "To: {{date}}",
    "save": "Save",
    "update": "Update",
    "cancel": "Cancel",
    "editTooltip": "Edit address",
    "removeTooltip": "Remove address",
    "addedSuccess": "Address added",
    "addError": "Failed to add address",
    "updatedSuccess": "Address updated",
    "updateError": "Failed to update address",
    "removedSuccess": "Address removed",
    "removeError": "Failed to remove address",
    "requiredError": "Address line 1 and country are required",
    "confirmRemoveTitle": "Remove Address",
    "confirmRemoveMessage": "Are you sure you want to remove this {{type}} address?",
    "confirmRemoveLabel": "Remove"
  },
  "allergies": {
    "pageTitle": "Allergies",
    "addAllergy": "Add Allergy",
    "loading": "Loading allergies...",
    "loadError": "Failed to load allergy information.",
    "nka": {
      "title": "No Known Allergies (NKA)",
      "body": "No allergies have been documented for this patient."
    },
    "sections": {
      "active": "Active Allergies ({{count}})",
      "inactive": "Inactive Allergies ({{count}})"
    },
    "fields": {
      "reaction": "Reaction",
      "severity": "Severity",
      "onset": "Onset",
      "recorded": "Recorded"
    },
    "inactiveSummary": "Reaction: {{reaction}} | Severity: {{severity}}",
    "deactivate": "Deactivate",
    "deactivateTooltip": "Deactivate allergy",
    "deleteTooltip": "Delete allergy",
    "deactivatedSuccess": "Allergy deactivated",
    "deactivateError": "Failed to deactivate allergy",
    "removedSuccess": "Allergy removed",
    "removeError": "Failed to remove allergy",
    "confirmDeactivateTitle": "Confirm Deactivation",
    "confirmDeactivateMessage": "Are you sure you want to deactivate \"{{name}}\"?",
    "confirmDeleteTitle": "Confirm Deletion",
    "confirmDeleteMessage": "Are you sure you want to permanently delete \"{{name}}\"?",
    "confirmLabel": "Confirm"
  },
  "problems": {
    "pageTitle": "Problem List",
    "addProblem": "Add Problem",
    "loading": "Loading problem list...",
    "loadError": "Failed to load problem list.",
    "tabs": {
      "active": "Active ({{count}})",
      "resolvedInactive": "Resolved / Inactive ({{count}})"
    },
    "sortByLabel": "Sort by:",
    "sortBy": {
      "onsetDate": "Onset Date",
      "severity": "Severity"
    },
    "status": {
      "label": "Status",
      "values": {
        "active": "Active",
        "resolved": "Resolved",
        "inactive": "Inactive"
      }
    },
    "empty": {
      "active": "No active problems recorded.",
      "resolved": "No resolved or inactive problems."
    },
    "fields": {
      "onset": "Onset",
      "resolved": "Resolved"
    },
    "resolveButton": "Resolve",
    "reactivateButton": "Reactivate",
    "resolveTooltip": "Mark as resolved",
    "reactivateTooltip": "Reactivate",
    "statusUpdatedSuccess": "Problem status updated",
    "statusUpdateError": "Failed to update problem status"
  },
  "immunizations": {
    "pageTitle": "Immunizations",
    "addImmunization": "Add Immunization",
    "loading": "Loading immunization records...",
    "loadError": "Failed to load immunization records.",
    "empty": "No immunization records found.",
    "dueOverdue": "Due / Overdue Immunizations ({{count}})",
    "upcoming": "Upcoming Immunizations ({{count}})",
    "dueLabel": "Due: {{date}}",
    "fromDateLabel": "From Date",
    "toDateLabel": "To Date",
    "fromDateAria": "Immunization date from",
    "toDateAria": "Immunization date to",
    "clearFilters": "Clear",
    "cvxLabel": "CVX: {{code}}",
    "columns": {
      "vaccine": "Vaccine",
      "date": "Date",
      "lotNumber": "Lot #",
      "site": "Site",
      "administeredBy": "Administered By",
      "nextDue": "Next Due",
      "status": "Status"
    },
    "dueStatus": {
      "label": "Status",
      "values": {
        "overdue": "Overdue",
        "dueToday": "Due Today",
        "upcoming": "Upcoming"
      }
    },
    "__review_dueStatus": "Vaccine due/overdue terminology may have facility- or jurisdiction-specific preferences in APAC (e.g., 'lapsed' vs 'overdue') — verify with local immunisation programme reviewer."
  },
  "contacts": {
    "pageTitle": "Contacts",
    "addContact": "Add Contact",
    "loading": "Loading contacts...",
    "loadError": "Failed to load contact information.",
    "empty": "No contacts on file.",
    "emergencyBadge": "Emergency",
    "sections": {
      "emergency": "Emergency Contacts ({{count}})",
      "other": "Other Contacts ({{count}})"
    },
    "editTooltip": "Edit contact",
    "deleteTooltip": "Delete contact",
    "deletedSuccess": "Contact deleted",
    "deleteError": "Failed to delete contact",
    "confirmDeleteTitle": "Delete Contact",
    "confirmDeleteMessage": "Are you sure you want to delete \"{{name}}\"?",
    "confirmDeleteLabel": "Delete"
  },
  "insurances": {
    "pageTitle": "Insurance",
    "addInsurance": "Add Insurance",
    "loading": "Loading insurance information...",
    "loadError": "Failed to load insurance information.",
    "empty": {
      "title": "No Insurance Plans",
      "body": "No insurance plans have been recorded for this patient."
    },
    "sections": {
      "active": "Active Plans ({{count}})",
      "inactive": "Inactive Plans ({{count}})"
    },
    "status": {
      "label": "Status",
      "values": {
        "active": "Active",
        "inactive": "Inactive",
        "pendingVerification": "Pending Verification"
      }
    },
    "fields": {
      "memberId": "Member ID",
      "groupNumber": "Group Number",
      "effectiveDate": "Effective Date",
      "terminationDate": "Termination Date",
      "copay": "Copay",
      "coinsurance": "Coinsurance",
      "deductible": "Deductible",
      "subscriber": "Subscriber"
    },
    "preAuthBadge": "Pre-authorization Required",
    "lastVerifiedLabel": "Last verified: {{date}}",
    "copayAmount": "${{amount}}",
    "coinsurancePercent": "{{percent}}%",
    "deductibleAmount": "${{amount}}",
    "verifyButton": "Verify",
    "verifyTooltip": "Verify eligibility",
    "editButton": "Edit",
    "verifySuccess": "Eligibility verification initiated",
    "verifyError": "Eligibility verification failed"
  },
  "identifiersTab": {
    "pageTitle": "Identifiers",
    "addIdentifier": "Add Identifier",
    "loading": "Loading identifiers...",
    "loadError": "Failed to load identifier information.",
    "empty": "No identifiers on file.",
    "newTitle": "New Identifier",
    "type": {
      "label": "Type",
      "selectPlaceholder": "Select type...",
      "values": {
        "externalMrn": "External MRN",
        "insuranceId": "Insurance ID",
        "studyId": "Study ID",
        "healthCard": "Health Card",
        "nationalRegistry": "National Registry",
        "passport": "Passport",
        "driverLicense": "Driver License",
        "other": "Other"
      }
    },
    "__review_type": "Identifier-type taxonomy (External MRN, Health Card, National Registry, etc.) is admin/legal terminology that varies by APAC jurisdiction — verify with local admin reviewer before APAC pilot rollout.",
    "fields": {
      "value": "Value",
      "assigningAuthority": "Assigning Authority",
      "effectiveDate": "Effective Date",
      "expiryDate": "Expiry Date"
    },
    "placeholders": {
      "value": "e.g. S1234567D",
      "assigningAuthority": "e.g. MOH Singapore"
    },
    "status": {
      "label": "Status",
      "values": {
        "active": "Active",
        "inactive": "Inactive"
      }
    },
    "columns": {
      "type": "Type",
      "value": "Value",
      "assigningAuthority": "Assigning Authority",
      "effectiveDate": "Effective Date",
      "expiryDate": "Expiry Date",
      "status": "Status",
      "actions": "Actions"
    },
    "save": "Save",
    "cancel": "Cancel",
    "removeTooltip": "Remove identifier",
    "addedSuccess": "Identifier added",
    "addError": "Failed to add identifier",
    "removedSuccess": "Identifier removed",
    "removeError": "Failed to remove identifier",
    "requiredError": "Type and value are required",
    "confirmRemoveTitle": "Remove Identifier",
    "confirmRemoveMessage": "Are you sure you want to remove \"{{type}}: {{value}}\"?",
    "confirmRemoveLabel": "Remove"
  },
  "pages": {
    "advanceDirectives": {
      "title": "Advance Directives",
      "addButton": "Add Directive",
      "emptyState": "No advance directives documented for this patient.",
      "loading": "Loading advance directives...",
      "loadError": "Failed to load advance directives.",
      "documentLink": "View Document",
      "effectivePrefix": "Effective:",
      "reviewPrefix": "Review:",
      "form": {
        "title": "New Advance Directive",
        "labels": {
          "directiveType": "Directive Type",
          "status": "Status",
          "effectiveDate": "Effective Date",
          "notes": "Notes",
          "optional": "optional"
        },
        "placeholders": {
          "notes": "Additional notes about the directive..."
        },
        "selectTypePlaceholder": "Select type...",
        "aria": {
          "effectiveDate": "Effective Date"
        },
        "buttons": {
          "save": "Save Directive",
          "cancel": "Cancel"
        }
      },
      "directiveType": {
        "DNR": "Do Not Resuscitate (DNR)",
        "living-will": "Living Will",
        "POLST": "POLST / MOLST",
        "healthcare-proxy": "Healthcare Proxy",
        "power-of-attorney": "Durable Power of Attorney"
      },
      "__review_directiveType": "Advance-directive taxonomy (DNR, POLST/MOLST, Healthcare Proxy, Durable Power of Attorney) is US/SG legal terminology — APAC jurisdictions vary substantially (HK Advance Medical Directive Ordinance, JP advance care planning, etc.). Verify with local clinical/legal reviewer before APAC pilot rollout. Acronyms (DNR, POLST, MOLST) stay verbatim across locales.",
      "directiveStatus": {
        "active": "Active",
        "inactive": "Inactive",
        "revoked": "Revoked",
        "pending": "Pending Review"
      },
      "toast": {
        "added": "Advance directive added",
        "addFailed": "Failed to add advance directive",
        "directiveTypeRequired": "Directive type is required"
      }
    },
    "familyHistory": {
      "title": "Family History",
      "addButton": "Add Entry",
      "emptyState": "No family history documented for this patient.",
      "loading": "Loading family history...",
      "loadError": "Failed to load family history.",
      "onsetAge": "Onset age: {{age}} years",
      "outcomePrefix": "Outcome:",
      "form": {
        "title": "New Family History Entry",
        "labels": {
          "relationship": "Relationship",
          "conditionName": "Condition Name",
          "conditionCode": "Condition Code",
          "onsetAge": "Onset Age",
          "outcome": "Outcome",
          "optional": "optional"
        },
        "placeholders": {
          "onsetAge": "Age in years"
        },
        "selectRelationshipPlaceholder": "Select relationship...",
        "selectOutcomePlaceholder": "Select outcome...",
        "buttons": {
          "save": "Save Entry",
          "cancel": "Cancel"
        }
      },
      "relationship": {
        "Mother": "Mother",
        "Father": "Father",
        "Sibling": "Sibling",
        "Maternal Grandmother": "Maternal Grandmother",
        "Maternal Grandfather": "Maternal Grandfather",
        "Paternal Grandmother": "Paternal Grandmother",
        "Paternal Grandfather": "Paternal Grandfather",
        "Child": "Child",
        "Aunt": "Aunt",
        "Uncle": "Uncle"
      },
      "__review_relationship": "Family-relationship taxonomy is APAC-jurisdiction-sensitive. Chinese, Japanese, and Korean distinguish paternal vs maternal grandparents lexically (e.g. zh 奶奶 paternal grandmother vs 外婆 maternal grandmother) — the paired wire values capture that distinction. However, 'Aunt' and 'Uncle' collapse distinctions that exist in zh/ja/ko (paternal aunt/uncle vs maternal aunt/uncle, elder vs younger sibling of parent). Flag for clinical reviewer pre-pilot; consider expanding the wire taxonomy in a future release if granular kinship is clinically required.",
      "outcome": {
        "alive": "Alive",
        "deceased": "Deceased",
        "unknown": "Unknown"
      },
      "toast": {
        "added": "Family history entry added",
        "addFailed": "Failed to add family history entry",
        "relationshipAndConditionRequired": "Relationship and condition are required"
      }
    },
    "socialHistory": {
      "title": "Social History",
      "editButton": "Edit",
      "loading": "Loading social history...",
      "loadError": "Failed to load social history.",
      "labels": {
        "smokingStatus": "Smoking Status",
        "alcoholUse": "Alcohol Use",
        "substanceUse": "Substance Use",
        "housing": "Housing",
        "employment": "Employment",
        "safetyScreening": "Safety Screening",
        "notes": "Notes"
      },
      "placeholders": {
        "notes": "Additional notes..."
      },
      "buttons": {
        "save": "Save Changes",
        "cancel": "Cancel"
      },
      "toast": {
        "updated": "Social history updated",
        "updateFailed": "Failed to update social history"
      },
      "smokingStatus": {
        "never": "Never Smoker",
        "former": "Former Smoker",
        "currentDaily": "Current Daily Smoker",
        "currentOccasional": "Current Occasional Smoker",
        "unknown": "Unknown"
      },
      "alcoholUse": {
        "None": "None",
        "Social/Occasional": "Social/Occasional",
        "Moderate": "Moderate",
        "Heavy": "Heavy",
        "In Recovery": "In Recovery",
        "Unknown": "Unknown"
      },
      "__review_alcoholUse": "Western framing — 'Social/Occasional' as a category collapses culturally distinct alcohol-use patterns across APAC. In JP/KR work-drinking culture, 'social' drinking can be both habitual and heavy by Western standards; SG/MY/ID populations with religious abstention may need separate non-drinker vs former-drinker distinctions. Flag for clinical reviewer pre-pilot; consider expanding the wire taxonomy in a future release.",
      "substanceUse": {
        "None": "None",
        "Current Use": "Current Use",
        "Former Use": "Former Use",
        "In Treatment": "In Treatment",
        "Unknown": "Unknown"
      },
      "housing": {
        "Stable": "Stable",
        "Unstable": "Unstable",
        "Homeless": "Homeless",
        "Assisted Living": "Assisted Living",
        "Nursing Facility": "Nursing Facility",
        "Unknown": "Unknown"
      },
      "__review_housing": "US/SG-centric housing taxonomy — 'Homeless' / 'Assisted Living' / 'Nursing Facility' map to US categorizations not all APAC jurisdictions recognize. HK uses public-housing vs subdivided-flat distinctions; JP elder-care has 介護施設 (kaigo shisetsu) sub-types not captured here; KR distinguishes 요양원 vs 양로원. Flag for clinical reviewer pre-pilot; consider region-specific housing taxonomies in a future release.",
      "employment": {
        "Employed Full-Time": "Employed Full-Time",
        "Employed Part-Time": "Employed Part-Time",
        "Self-Employed": "Self-Employed",
        "Unemployed": "Unemployed",
        "Retired": "Retired",
        "Student": "Student",
        "Disabled": "Disabled",
        "Unknown": "Unknown"
      },
      "safetyScreening": {
        "No Concerns": "No Concerns",
        "Concerns Identified": "Concerns Identified",
        "Declined to Answer": "Declined to Answer",
        "Not Screened": "Not Screened"
      },
      "__review_safetyScreening": "Safety-screening framework is jurisdiction-specific. US/SG hospitals run standardized IPV / elder-abuse screening protocols; HK statutory framework (Family & Domestic Violence Ordinance) uses different reporting categories; JP/KR follow Mandatory Reporting Acts with separate disclosure categories. The 4-value taxonomy here captures only the screening-status axis, not the screening type. Flag for clinical reviewer pre-pilot."
    },
    "surgicalHistory": {
      "title": "Surgical History",
      "addButton": "Add Procedure",
      "emptyState": "No surgical history documented for this patient.",
      "loading": "Loading surgical history...",
      "loadError": "Failed to load surgical history.",
      "cptLabel": "CPT {{code}}",
      "dateLabel": "Date: {{date}}",
      "surgeonLabel": "Surgeon: {{name}}",
      "anesthesiaLabel": "Anesthesia: {{type}}",
      "outcomePrefix": "Outcome:",
      "complicationsPrefix": "Complications:",
      "form": {
        "title": "New Surgical History Entry",
        "labels": {
          "procedureName": "Procedure Name",
          "procedureCode": "Procedure Code",
          "procedureCodeSuffix": "(CPT)",
          "date": "Date",
          "surgeonName": "Surgeon Name",
          "anesthesiaType": "Anesthesia Type",
          "laterality": "Laterality",
          "outcome": "Outcome",
          "complications": "Complications"
        },
        "placeholders": {
          "surgeonName": "Surgeon name",
          "complications": "Any complications..."
        },
        "selectPlaceholder": "Select...",
        "aria": {
          "procedureDate": "Procedure Date"
        },
        "buttons": {
          "save": "Save Entry",
          "cancel": "Cancel"
        }
      },
      "__review_procedureCode": "CPT (Current Procedural Terminology) is a US-specific procedural-coding standard maintained by the American Medical Association — APAC jurisdictions typically use SNOMED-CT or ICD-10-PCS variants instead (SG MOH uses ICD-10-AM ACHI for procedures; HK/JP/KR/AU use national derivatives). The literal label 'CPT' should NOT be localized as a translatable word, but the procedure-code field semantics MAY require region-specific labelling (e.g. 'ICD-10-PCS' / 'ACHI') in a future release. Flag for clinical reviewer pre-pilot.",
      "anesthesiaType": {
        "general": "General",
        "regional": "Regional",
        "local": "Local",
        "spinal": "Spinal",
        "epidural": "Epidural",
        "sedation": "Sedation",
        "none": "None",
        "unknown": "Unknown"
      },
      "laterality": {
        "left": "Left",
        "right": "Right",
        "bilateral": "Bilateral"
      },
      "toast": {
        "added": "Surgical history entry added",
        "addFailed": "Failed to add surgical history entry",
        "procedureNameRequired": "Procedure name is required"
      }
    },
    "referralManagement": {
      "title": "Referrals",
      "addButton": "New Referral",
      "refresh": "Refresh",
      "loading": "Loading referrals...",
      "errorState": "Failed to load referrals.",
      "emptyState": "No referrals for this patient.",
      "emptyStateFiltered": "No referrals matching the selected status.",
      "ariaFilterStatus": "Filter referrals by status",
      "externalBadge": "External",
      "filterStatus": {
        "allLabel": "All Statuses"
      },
      "table": {
        "type": "Type",
        "reason": "Reason",
        "specialty": "Specialty",
        "priority": "Priority",
        "status": "Status",
        "requested": "Requested",
        "target": "Target"
      },
      "form": {
        "title": "New Referral",
        "labels": {
          "referralType": "Referral Type",
          "priority": "Priority",
          "specialty": "Specialty",
          "reason": "Reason",
          "targetDate": "Target Date",
          "clinicalNotes": "Clinical Notes",
          "optional": "optional"
        },
        "placeholders": {
          "reason": "Reason for referral",
          "clinicalNotes": "Additional clinical notes..."
        },
        "selectReferralTypePlaceholder": "Select type...",
        "selectSpecialtyPlaceholder": "Select specialty...",
        "buttons": {
          "create": "Create Referral",
          "cancel": "Cancel"
        }
      },
      "referralType": {
        "consultation": "Consultation",
        "transfer": "Transfer of Care",
        "second-opinion": "Second Opinion",
        "diagnostic": "Diagnostic",
        "therapeutic": "Therapeutic"
      },
      "priority": {
        "routine": "Routine",
        "urgent": "Urgent",
        "stat": "STAT"
      },
      "__review_priority": "Referral-priority taxonomy (routine / urgent / STAT) is US/SG clinical-referral terminology — APAC jurisdictions vary. JP referral systems (紹介状) traditionally use 'normal / urgent / emergency' without a separate STAT acronym; KR uses 일반/응급/긴급 with a different urgency boundary; HK Hospital Authority referral codes use a 4-tier triage system (T1-T4). The literal 'STAT' should NOT be translated as a word (it's a Latin acronym for 'statim'), but the priority-tier label semantics MAY require region-specific re-categorization in a future release. Flag for clinical reviewer pre-pilot.",
      "status": {
        "draft": "Draft",
        "submitted": "Submitted",
        "accepted": "Accepted",
        "scheduled": "Scheduled",
        "completed": "Completed",
        "cancelled": "Cancelled"
      },
      "toasts": {
        "createSuccess": "Referral created",
        "createFailed": "Failed to create referral",
        "validationFailed": "Referral type and reason are required"
      }
    }
  },
  "consents": {
    "title": "Consents",
    "grant": "Grant consent",
    "revoke": "Revoke",
    "confirmRevoke": "Revoke this consent? This records a revocation event and cannot be undone.",
    "loading": "Loading consents…",
    "loadError": "Failed to load consents.",
    "empty": "No consent records for this patient.",
    "table": {
      "scope": "Scope",
      "category": "Category",
      "decision": "Decision",
      "status": "Status",
      "effective": "Effective",
      "recorded": "Recorded",
      "actions": "Actions",
      "history": "Event history"
    },
    "toast": {
      "revoked": "Consent revoked.",
      "revokeFailed": "Failed to revoke consent."
    },
    "scope": {
      "patientPrivacy": "Patient privacy",
      "research": "Research",
      "treatment": "Treatment",
      "adr": "Adverse drug reaction"
    },
    "decision": {
      "permit": "Permit",
      "deny": "Deny"
    },
    "status": {
      "draft": "Draft",
      "proposed": "Proposed",
      "active": "Active",
      "rejected": "Rejected",
      "inactive": "Inactive",
      "enteredInError": "Entered in error"
    },
    "eventType": {
      "granted": "Granted",
      "revoked": "Revoked",
      "evaluated": "Evaluated",
      "accessGranted": "Access granted",
      "accessDenied": "Access denied"
    },
    "events": {
      "loading": "Loading history…",
      "empty": "No events recorded."
    },
    "form": {
      "title": "Grant consent",
      "submit": "Grant consent",
      "savedSuccess": "Consent recorded.",
      "saveError": "Failed to record consent."
    },
    "fields": {
      "scope": "Scope",
      "decision": "Decision",
      "category": "Category",
      "categoryPlaceholder": "e.g. medical-records, imaging",
      "performer": "Performer",
      "performerPlaceholder": "e.g. Patient/123 or Practitioner/45",
      "purpose": "Purpose",
      "dataClass": "Data class",
      "effectiveFrom": "Effective from",
      "effectiveTo": "Effective to",
      "notes": "Notes"
    }
  },
  "pregnancy": {
    "title": "Pregnancy & Lactation Screening",
    "currentHeading": "Current status",
    "recordHeading": "Record a status",
    "historyHeading": "History",
    "pregnancyLabel": "Pregnancy",
    "lactationLabel": "Lactation",
    "eddLabel": "Estimated due date",
    "sourceLabel": "Source",
    "notesLabel": "Notes",
    "recordButton": "Record status",
    "recordedOn": "Recorded {{date}}",
    "eddOn": "Estimated due date {{date}}",
    "outOfDate": "Out of date",
    "neverAsked": "Never asked",
    "notRecorded": "Not recorded",
    "noHistory": "No screening has been recorded for this patient.",
    "savedSuccess": "Screening status recorded",
    "saveError": "Could not record the screening status",
    "status": {
      "pregnant": "Pregnant",
      "notPregnant": "Not pregnant",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "lactationStatus": {
      "lactating": "Lactating",
      "notLactating": "Not lactating",
      "unknown": "Not known",
      "declined": "Declined to answer",
      "notApplicable": "Not applicable"
    },
    "source": {
      "patientReported": "Patient reported",
      "clinician": "Clinician",
      "lab": "Laboratory"
    },
    "columns": {
      "recordedAt": "Recorded",
      "pregnancy": "Pregnancy",
      "lactation": "Lactation",
      "edd": "Due date",
      "source": "Source",
      "notes": "Notes"
    },
    "errors": {
      "notesTooLong": "Notes must be 1000 characters or fewer",
      "eddOnlyWhenPregnant": "An estimated due date applies only to a pregnant status"
    }
  },
  "nursingAssessment": {
    "title": "Nursing Assessment",
    "subtitle": "The Morse and Braden scores recorded here update this patient's risk badges.",
    "assessmentType": "Assessment type",
    "type": {
      "admission": "Admission",
      "shift": "Shift",
      "focused": "Focused",
      "discharge": "Discharge"
    },
    "levelOfConsciousness": "Level of consciousness",
    "loc": {
      "alert": "Alert",
      "drowsy": "Drowsy",
      "lethargic": "Lethargic",
      "confused": "Confused",
      "unresponsive": "Unresponsive"
    },
    "mobilityLevel": "Mobility",
    "mobility": {
      "independent": "Independent",
      "assistiveDevice": "Assistive device",
      "assistOfOne": "Assist of one",
      "assistOfTwo": "Assist of two",
      "bedbound": "Bedbound"
    },
    "fallRiskFactors": "Fall risk factors",
    "fallRiskFactorsPlaceholder": "e.g. unsteady gait, IV pole, sedation",
    "pressureInjuryPresent": "Pressure injury already present",
    "painAssessment": "Pain assessment",
    "painPlaceholder": "Site, character, score, intervention",
    "generalNotes": "General notes",
    "save": "Save assessment",
    "saving": "Saving…",
    "saved": "Assessment recorded",
    "saveFailed": "Could not record the assessment",
    "notClinical": "Your account has no clinical identity, so it cannot sign a nursing assessment.",
    "history": "Previous assessments",
    "historyEmpty": "No assessments recorded for this encounter yet.",
    "bands": "Fall: {{fall}} · Pressure: {{pressure}}",
    "notScored": "not scored",
    "__review_nursingAssessment": "UNTRANSLATED OUTSIDE en/en-SG — every non-English locale currently carries the English string verbatim and MUST be reviewed before ship. The clinical vocabularies here vary by APAC nursing standard and are not safe to machine-translate: level-of-consciousness terms (alert/drowsy/lethargic/confused/unresponsive) map onto locally-taught scales (AVPU vs GCS descriptors; JP 意識レベル uses JCS 3-3-9度, which has no 1:1 English equivalent), and mobility tiers (assist of one / assist of two) follow local manual-handling policy rather than a shared taxonomy. assessment_type values are the wire contract and must NOT be localised. Nursing lead per APAC market signs off before ship."
  },
  "duplicates": {
    "title": "Duplicate Review",
    "subtitle": "Candidate duplicate records found by the matching scanner. Review each pair and merge, or record that they are different people.",
    "noPermission": "You do not have permission to review duplicate patient records.",
    "loading": "Loading candidates...",
    "loadFailed": "Could not load the duplicate worklist.",
    "empty": "No candidates to review.",
    "dismissed": "Decision recorded.",
    "dismissFailed": "Could not record the decision.",
    "prev": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{totalPages}}",
    "columns": {
      "score": "Score",
      "patients": "Records",
      "matchedOn": "Matched on",
      "detected": "Detected",
      "actions": "Actions"
    },
    "filters": {
      "status": "Review status",
      "minScore": "Min score"
    },
    "status": {
      "pending": "Pending",
      "reviewed": "Reviewed",
      "merged": "Merged",
      "not_duplicate": "Not a duplicate",
      "ignored": "Ignored"
    },
    "confidence": {
      "very_high": "Very high",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "matchedField": {
      "nameMatch": "Name",
      "dobMatch": "Date of birth",
      "genderMatch": "Gender",
      "nationalIdMatch": "National ID",
      "phoneMatch": "Phone",
      "addressMatch": "Address"
    },
    "actions": {
      "review": "Review",
      "dismiss": "Not a duplicate"
    },
    "dismissDialog": {
      "title": "Record a review decision",
      "body": "{{name1}} ({{mrn1}}) and {{name2}} ({{mrn2}}) will be removed from the worklist.",
      "reasonHelp": {
        "not_duplicate": "These are different people. The pair will not return unless the matching evidence materially improves.",
        "ignored": "Do not action this pair for now. Same suppression rule applies."
      },
      "notesPlaceholder": "Notes (optional)",
      "cancel": "Cancel",
      "confirm": "Record decision"
    },
    "restricted": {
      "title_one": "{{count}} pair involves a patient you cannot view",
      "title_other": "{{count}} pairs involve a patient you cannot view",
      "body": "One of your patients may be a duplicate of a record at another facility. The pair is not listed because judging it would mean seeing a patient outside your access — ask Health Information Management to review it."
    }
  },
  "recordExport": {
    "button": "Export record",
    "exporting": "Exporting…",
    "success": "Record exported",
    "failed": "Export failed — nothing was downloaded",
    "tooltip": "Download this patient's complete record as a portable file"
  },
  "device": {
    "addTitle": "Record Implantable Device",
    "editTitle": "Record Explant",
    "deviceName": "Device name",
    "deviceNamePlaceholder": "e.g., Evera MRI ICD, drug-eluting stent",
    "deviceNameTooLong": "Device name must be 512 characters or fewer",
    "deviceType": "Device type",
    "deviceTypePlaceholder": "e.g., pacemaker, stent, prosthesis",
    "udi": "UDI",
    "udiPlaceholder": "Unique Device Identification carrier",
    "deviceCode": "Device code",
    "deviceCodeSystem": "Code system",
    "deviceCodeSystemPlaceholder": "e.g., GMDN, SNOMED CT",
    "manufacturer": "Manufacturer",
    "modelNumber": "Model",
    "lotNumber": "Lot number",
    "serialNumber": "Serial number",
    "implantDate": "Implant date",
    "explantDate": "Explant date",
    "status": "Status",
    "statusOptions": {
      "active": "Active",
      "inactive": "Inactive",
      "explanted": "Explanted"
    },
    "mriSafety": "MRI safety",
    "mriSafetyOptions": {
      "safe": "Safe",
      "conditional": "Conditional",
      "unsafe": "Unsafe",
      "unknown": "Unknown"
    },
    "notes": "Notes",
    "notesPlaceholder": "Additional notes...",
    "savedSuccess": "Device recorded successfully",
    "saveError": "Failed to record device",
    "updatedSuccess": "Explant recorded successfully",
    "updateError": "Failed to record explant",
    "explantRequiresDate": "An explanted device needs an explant date",
    "explantBeforeImplant": "Explant date cannot be before implant date"
  },
  "devices": {
    "pageTitle": "Implantable Devices",
    "addDevice": "Record Device",
    "loading": "Loading devices...",
    "loadError": "Failed to load device information.",
    "empty": {
      "title": "No Implantable Devices",
      "body": "No devices have been recorded for this patient."
    },
    "sections": {
      "active": "Active Devices ({{count}})",
      "history": "Explanted / Inactive ({{count}})"
    },
    "fields": {
      "udi": "UDI",
      "manufacturer": "Manufacturer",
      "implanted": "Implanted",
      "explanted": "Explanted",
      "mriSafety": "MRI safety",
      "recorded": "Recorded"
    },
    "recordExplant": "Record explant",
    "explantTooltip": "Record removal of this device",
    "removeTooltip": "Remove entry",
    "removedSuccess": "Device entry removed",
    "removeError": "Failed to remove device entry",
    "confirmDeleteTitle": "Confirm Removal",
    "confirmDeleteMessage": "Remove \"{{name}}\" from the list? Only remove entries recorded in error — to record a removal from the body, use Record explant.",
    "confirmLabel": "Confirm"
  },
  "ccdaImports": {
    "title": "C-CDA Imports",
    "subtitle": "Documents received for reconciliation. Open an import to review each entry into the chart.",
    "empty": "No imported documents for this patient.",
    "loadError": "Could not load imports.",
    "received": "Received",
    "docType": "Type",
    "status": "Status",
    "pending": "Pending",
    "entries": "Entries",
    "match": "Match",
    "mismatch": "ID mismatch",
    "statuses": {
      "pending": "Pending",
      "reviewed": "Reviewed",
      "dismissed": "Dismissed"
    },
    "docTypes": {
      "ccd": "CCD",
      "referral-note": "Referral note",
      "discharge-summary": "Discharge summary",
      "other": "Other"
    }
  },
  "ccdaReview": {
    "title": "Import #{{id}}",
    "back": "Back to imports",
    "loadError": "Could not load this import.",
    "mismatchWarning": "The sender identifiers do not match this patient. Verify the document belongs here before accepting anything.",
    "unnamed": "Unnamed entry",
    "accept": "Accept",
    "reject": "Reject",
    "accepted": "Entry merged into the chart",
    "rejected": "Entry rejected",
    "alreadyReviewed": "Already reviewed by someone else — refreshed below",
    "reviewError": "Review failed",
    "confirmAcceptTitle": "Accept into the chart?",
    "confirmAcceptMessage": "“{{name}}” will be added to this patient’s chart.",
    "confirmRejectTitle": "Reject this entry?",
    "confirmRejectMessage": "“{{name}}” will be dropped from the queue. The raw document stays filed.",
    "sections": {
      "problem": "Problems",
      "medication": "Medications",
      "allergy": "Allergies"
    },
    "statuses": {
      "accepted": "Accepted",
      "rejected": "Rejected"
    }
  }
}
